<template>
  <div v-if="lastRoute">
    <div class="flex items-center cursor-pointer hover:text-grey-lighter" @click="handleLastRoute">
      <DrIcon svg="angle-left" width="24" height="24" />
      <span class="text-3xs leading-tight font-bold">back</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      orignialProductData: {},
    }
  },
  computed: {
    configuredProducts () {
      return this.$store.getters.getProducts
    },
    isConfigPage () {
      return this.$route.path.endsWith('/config')
    },
    isStatementPage () {
      return this.$route.path.startsWith('/statements')
    },
    statements () {
      return this.$store.getters.getStatements
    },
    lastRoute () {
      if (this.isStatementPage) {
        const statementIndex = this.statements.findIndex(statement => statement.id === this.$route.params.id)
        if (statementIndex === 0) return '/overview'
        else return `/statements/${this.statements[statementIndex - 1].id}`
      } else if (this.$route.path === '/quote-confirmation') {
        return `/statements/${this.statements[this.statements.length - 1].id}`
      } else if (this.$store.state.portal && this.$route.path === '/products') {
        return null
      } else {
        return this.$route.meta.back
      }
    },
  },
  methods: {
    handleLastRoute () {
      this.$router.push(this.lastRoute)
    },
  },
}
</script>
